// extracted by mini-css-extract-plugin
module.exports = {"offeringImage":"editable-entities_offeringImage__OIKKh","divider":"editable-entities_divider__ov_8n","editableOfferingSection":"editable-entities_editableOfferingSection__hDJnZ"};